import CartItem from "../components/Cart/CartItem";
import { useShopContext } from "../context/ShopContext";
import { formatGR } from "../utils/formatGR";
import { Button, Container, Form, Modal, Row, Spinner } from "react-bootstrap";
import { SendOrderToLocs } from "../hooks/SendOrderToLocs";
import styles from "../styles/Product.module.css";
import { useState } from "react";
import { User } from "../models/user";
import { BsArrowLeftCircleFill, BsFillSendFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

interface CartPageProps {
    loggedInUser: User | null;
}

const CartPage = ({ loggedInUser }: CartPageProps) => {

    const { calculateTotal, cartItems, setCartItems } = useShopContext();
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showFailModal, setShowFailModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [comments, setComments] = useState('');
    const totalAmount = calculateTotal();
    const navigate = useNavigate();

    const handleSendOrderClick = (loggedInUser: User) => {
        try {
            setLoading(true);
            SendOrderToLocs("orders@locs.gr", "Παραγγελία - " + loggedInUser.name + " " + loggedInUser.lastname, cartItems, comments, loggedInUser);       //send mail to Locs
            SendOrderToLocs(loggedInUser.username, "Locs - Επιβεβαίωση παραγγελίας", cartItems, comments, loggedInUser);                                     //send mail copy to customer
            setLoading(false);
            setShowSuccessModal(true);
        } catch (error) {
            setLoading(false);
            setShowFailModal(true);
        }
    };

    const handleModalOK = () => {
        setShowSuccessModal(false);
        setCartItems([]);
        setComments('');
        localStorage.removeItem('cartItems');
    };

    const handleGoHome = () => {
        navigate('/');
    }

    return (
    <>
        {
            loggedInUser
            && (
            <>
                <Container className="bg-light">
                    <div>
                        <h3 className="text-black text-center pt-3">{totalAmount > 0 ? "Καλάθι" : "Άδειο καλάθι!"}</h3>
                    </div>
                    <Row xs={1} md={1} lg={1} xl={1} className="g-1 px-0 justify-content-center">
                        {cartItems.map(item => {
                                return <CartItem key={item.ID} cartItem={item} />;
                        })}
                    </Row>
                    <Row className={`ms-auto me-auto ${styles.cartControls}`}>
                        {totalAmount > 0
                        ?
                        <>
                            <div>
                                <h3 className="text-black text-end mt-3 mb-4">Σύνολο: {formatGR(totalAmount)}€</h3>
                            </div>
                            <Form.Label>Παρατηρήσεις <span><small>(προαιρετικά)</small></span>
                                <Form.Control as="textarea" name="comments" rows={3} value={comments}  onChange={(e) => setComments(e.target.value)} />
                                <div className="d-flex justify-content-around py-4">
                                    {
                                        cartItems.length > 0 &&
                                        (<>
                                            <Button className="btn-dark" onClick={() => { handleGoHome() }}><BsArrowLeftCircleFill /> Συνέχεια Αγορών</Button>
                                            <Button className="btn-success" onClick={() => { handleSendOrderClick(loggedInUser) }}>Παραγγελία <BsFillSendFill /></Button>
                                        </>)
                                    }
                                </div>
                            </Form.Label>
                        </>
                        :
                        <>
                            <div className="d-flex justify-content-around py-4">
                                <Button className="btn-dark" onClick={() => { handleGoHome() }}><BsArrowLeftCircleFill /> Συνέχεια Αγορών</Button>
                                <Button className="btn-success" disabled>Παραγγελία <BsFillSendFill /></Button>
                            </div>
                        </>
                        }
                    </Row>
                </Container>
                {showSuccessModal
                &&
                (
                <Modal show centered>
                    <Modal.Header>
                        <Modal.Title>
                            Τέλεια!
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Λάβαμε την παραγγελία και θα σας ειδοποιήσουμε αμέσως μόλις είναι έτοιμη!
                    </Modal.Body>
                    <Modal.Footer>
                            <Button onClick = { handleModalOK }
                            type="submit"
                            className="w-100 btn-dark">
                            ΟΚ
                        </Button>
                    </Modal.Footer>
                </Modal>)
                }

                {showFailModal
                &&
                (
                <Modal show centered size="sm">
                    <Modal.Header>
                        <Modal.Title>
                            Ωχ!
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Δεν μπορέσαμε να στείλουμε το email με την παραγγελία σας 😢</p>
                        <p>Παρακαλούμε ενημερώστε μας για το σφάλμα καλώντας στο τηλ. ☎️2531022522</p>
                    </Modal.Body>
                    <Modal.Footer>
                            <Button onClick = {()=>setShowFailModal(false)}
                            type="submit"
                            className="w-100 btn-dark">
                            ΟΚ
                        </Button>
                    </Modal.Footer>
                </Modal>)
                }

                {loading && (
                    <Container className="d-flex align-items-center justify-content-center">
                        <Spinner className="LoadingSpinner" animation="border" role="status" variant="secondary">
                            <span className="visually-hidden">Περιμένετε λίγο...</span>
                        </Spinner>
                    </Container>)
                }
            </>
            )
        }
    </>
    );
};

export default CartPage;